// extracted by mini-css-extract-plugin
export default {"sectionWrap":"Products_sectionWrap__E+OK4","isFirstSection":"Products_isFirstSection__5elIV"};